import debounce from 'lodash/debounce';
// http://idangero.us/swiper/
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
// import Swiper and modules styles
import 'swiper/css'; /* eslint-disable-line import/no-unresolved */
import 'swiper/css/navigation'; /* eslint-disable-line import/no-unresolved */
import 'swiper/css/pagination'; /* eslint-disable-line import/no-unresolved */

const slideshows = document.querySelectorAll('[data-swiper-id]');
slideshows.forEach((slideshow) => {
    const id = slideshow.dataset.swiperId;
    const { swiperType, swiperColumns } = slideshow.dataset;
    const type = swiperType || 'slideshow';
    const columns = swiperColumns ? parseInt(swiperColumns, 10) : null;
    let autoplay = false;
    /* eslint-disable eqeqeq */
    if (slideshow.dataset.swiperAutoplay && slideshow.dataset.swiperAutoplay === '1') {
        autoplay = { delay: 5000 };
    }
    /* eslint-enable eqeqeq */
    const miniCardBreakpointsByColumns = {
        2: {
            320: { slidesPerView: 1 },
            400: { slidesPerView: 1 },
            600: { slidesPerView: 1 },
            768: { slidesPerView: 1 },
            980: { slidesPerView: 2 },
            1024: { slidesPerView: 2 },
            1280: { slidesPerView: 2 },
        },
        3: {
            320: { slidesPerView: 1 },
            400: { slidesPerView: 1 },
            600: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            980: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1280: { slidesPerView: 3 },
        },
        4: {
            320: { slidesPerView: 1 },
            400: { slidesPerView: 1 },
            600: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            980: { slidesPerView: 3 },
            1024: { slidesPerView: 4 },
            1280: { slidesPerView: 4 },
        },
        5: {
            320: { slidesPerView: 1 },
            400: { slidesPerView: 1 },
            600: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            980: { slidesPerView: 4 },
            1024: { slidesPerView: 5 },
            1280: { slidesPerView: 5 },
        },
        6: {
            320: { slidesPerView: 1 },
            400: { slidesPerView: 2 },
            600: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            980: { slidesPerView: 5 },
            1024: { slidesPerView: 6 },
            // 1280: { slidesPerView: 7},
        },
        7: {
            320: { slidesPerView: 2 },
            400: { slidesPerView: 2 },
            600: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            980: { slidesPerView: 5 },
            1024: { slidesPerView: 6 },
            1280: { slidesPerView: 7 },
        },
    };
    const configs = {
        slideshow: {
            autoplay,
            loop: true,
            delay: 6000,
            modules: [Navigation, Autoplay],
            navigation: {
                nextEl: `[data-next="${id}"]`,
                prevEl: `[data-prev="${id}"]`,
            },

        },
        'mini-cards': {
            autoplay,
            slidesPerView: 1,
            spaceBetween: 18,
            slidesPerGroup: 1,
            loop: true,
            delay: 6000,
            loopFillGroupWithBlank: true,
            modules: [Navigation, Pagination],
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: `[data-next="${id}"]`,
                prevEl: `[data-prev="${id}"]`,
            },
            // when window width is >= breakpoint
            breakpoints: miniCardBreakpointsByColumns[columns],
        },
    };

    const slider = new Swiper(slideshow, configs[type]); // eslint-disable-line no-unused-vars

    // set up image height if mini-cards
    if (type === 'mini-cards') {
        const updateImageHeight = () => {
            const image = slideshow.querySelector('.MiniCard__image img');
            slideshow.parentElement.style.setProperty('--image-height', `${image.offsetHeight}px`);
        };

        updateImageHeight();
        window.addEventListener('resize', debounce(updateImageHeight, 100, 'immediate'));
    }
});
